<template>
  <!--发起的签署-->
  <div class="main-container">
    <div class="signerHeader">
      <div class="leftHeader">
        <div></div>常用签署方
      </div>
    </div>
    <div style="padding: 15px 10px 0px 15px">
      <el-row type="flex">
        <el-col :span="8">
          <el-row type="flex" :gutter="10">
            <el-col :span="4">
              <el-button @click="editSigner(null, '添加联系人')" size="small">添加</el-button>
            </el-col>
            <el-col :span="6">
              <el-upload
                action
                :auto-upload="false"
                :show-file-list="false"
                :on-change="importSigners"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              >
                <el-button slot="trigger" size="small">批量添加</el-button>
              </el-upload>
            </el-col>
            <el-col :span="6">
              <el-button size="small" @click="tplDown">模板下载</el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="16">
          <el-row type="flex" justify="end" :gutter="10" style="margin-right: 0px">
            <el-col :span="6">
              <el-input
                v-model="queryParam.accountNo"
                size="small"
                placeholder="账号"
                style="max-width: 200px"
              />
            </el-col>
            <el-col :span="6">
              <el-input
                v-model="queryParam.name"
                size="small"
                placeholder="名称"
                style="max-width: 200px"
              />
            </el-col>
            <el-col :span="6">
              <el-input
                v-model="queryParam.idNo"
                size="small"
                placeholder="证件号"
                style="max-width: 200px"
              />
            </el-col>
            <el-col :span="2">
              <el-button @click="queryList()" size="small">查询</el-button>
            </el-col>
            <el-col :span="2">
              <el-button @click="rest" size="small">重置</el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div style="padding: 0 10px; margin-top: 15px">
      <el-table
        v-loading="loading"
        border
        :data="tableList"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        :header-cell-style="{
          background: '#f9f9f9',
          color: '#333333',
          fontWeight: '600',
        }"
        key="typeOther"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="账号" prop="mobileOrChild" show-overflow-tooltip />
        <el-table-column label="名称" prop="enterpriseName" show-overflow-tooltip />
        <el-table-column label="证件号" prop="businessLicense" show-overflow-tooltip />
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <a
              @click="editSigner(scope.row, '修改联系人')"
              href="javascript:void (0)"
              class="color-success pointer"
              style="margin-right: 5px"
            >修改</a>
            <a
              @click="delSigners(scope.row)"
              href="javascript:void (0)"
              class="color-success pointer"
              style="margin-right: 5px"
            >删除</a>
          </template>
        </el-table-column>
        <no-data text="暂无数据" slot="empty" />
      </el-table>
    </div>

    <!--分页-->
    <el-row class="pageation row">
      <el-col :span="4">
        <el-button @click="delSigners()" size="mini">删除</el-button>
      </el-col>
      <el-col :span="20" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParam.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="queryParam.total"
        />
        <el-go
          :page-size="queryParam.pageSize"
          :total="queryParam.total"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>

    <el-dialog
      :visible.sync="showEditSignerDialog"
      :close-on-click-modal="false"
      width="400px"
      :title="this.title"
      :key="editSignerDialogKey"
    >
      <div>
        <div style="text-align: center; margin-top: 15px">
          <el-form
            label-width="100px"
            key="bank"
            :model="editSignerFrm"
            :rules="editSignerFrmRules"
            ref="editSignerFrm"
          >
            <el-form-item label="手机号/邮箱" prop="mobileOrEmail">
              <el-input placeholder="请输入手机号/邮箱" v-model="editSignerFrm.mobileOrEmail" />
            </el-form-item>
            <el-form-item label="签署方名称" prop="enterpriseName">
              <el-input placeholder="请输入签署方名称" v-model="editSignerFrm.enterpriseName" />
            </el-form-item>
            <el-form-item label="证件号" prop="businessLicense">
              <el-input placeholder="请输入证件号" v-model="editSignerFrm.businessLicense" />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="showEditSignerDialog = false" size="small" style="width: 120px">关闭</el-button>
        <el-button
          type="primary"
          size="small"
          style="width: 120px; color: #fff"
          @click="editSignerSubmit()"
        >提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ApiMethods } from "../../assets/js/http-serve/http-methods";
import ElGo from "../../components/go/Go";
export default {
  components: { ElGo },
  data () {
    return {
      title: "",
      tableList: null,
      loading: false,
      queryParam: {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        name: null,
        idNo: null,
        accountNo: null,
        mQuery: null
      },
      checkedList: [],
      showEditSignerDialog: false,
      editSignerDialogKey: "",
      editSignerFrm: {
        listId: "",
        mobileOrEmail: "",
        enterpriseName: "",
        businessLicense: ""
      },
      editSignerFrmRules: {
        mobileOrEmail: [
          {
            validator: this.$validator.required,
            trigger: "change",
            message: "手机号/邮箱不能为空"
          },
          { validator: this.$validator.mobileOrEmail, trigger: "change" }
        ],
        enterpriseName: [
          {
            validator: this.$validator.required,
            trigger: "change",
            message: "签署方名称不能为空"
          },
          { validator: this.$validator.specialVal, trigger: "change" },
          {
            validator: this.$validator.lengthRank,
            minLength: 2,
            maxLength: 20,
            trigger: "change"
          }
        ],
        businessLicense: [
          {
            validator: this.$validator.required,
            trigger: "change",
            message: "证件号不能为空"
          },
          { validator: this.$validator.certificateNo, trigger: "change" }
        ]
      }
    };
  },
  beforeMount () {
    this.queryList();
  },
  methods: {
    editSigner (signer, title) {
      this.title = title;
      this.editSignerDialogKey = "editSignerDialogKey" + new Date().getTime();
      if (signer) {
        this.editSignerFrm = {
          listId: signer.listId,
          mobileOrEmail: signer.mobileOrChild,
          enterpriseName: signer.enterpriseName,
          businessLicense: signer.businessLicense
        };
        this.showEditSignerDialog = true;
      } else {
        this.editSignerFrm = {};
        this.showEditSignerDialog = true;
      }
    },
    delSigners (item) {
      var _this = this;
      var dels = item ? [item] : _this.checkedList;
      var listIds = _this.$utils.selectArrField(dels, "listId");
      if (listIds.length < 1) {
        return _this.$message.error("你还未选择要操作的数据");
      }
      _this
        .$confirm("确定删除", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          ApiMethods.UseEnterpriseController.deleteEnterpriseList({
            listIds: listIds.join(",")
          }).then(result => {
            if (result.success) {
              _this.queryList();
              _this.$message.success("操作成功");
            } else {
              _this.$message.error(result.description || this.$tip);
            }
          });
        })
        .catch(() => { });
    },
    tplDown () {
      //首先点击下载事件时创建一个a标签
      let link = document.createElement("a");
      //将a标签隐藏
      link.style.display = "none";
      //给a标签添加下载链接  "域名+接口"
      //safe是一个动态的域名(safe是ip地址，需要自己定义)
      //后面拼接的是接口，替换成你自己的下载接口和需要传递的参数
      link.href = "/template/通讯录.xlsx";
      // 此处给a标签添加一个download属性，属性值就是文件名称否则下载出来的文件是没有属性的
      //下面代码，name会有斜杠，不影响使用
      link.setAttribute("download", name);
      //将上面创建的a标签加入到body的尾部
      document.body.appendChild(link);
      //最后执行a标签
      link.click();
    },
    importSigners (file) {
      var _this = this;
      var frm = new FormData();
      frm.append("file", file.raw);
      ApiMethods.UseEnterpriseController.uploadEnterpriseList(frm).then(
        result => {
          if (result.success) {
            _this.$message.success("操作成功");
            _this.queryList();
          } else {
            _this.$message.error(result.description || this.$tip);
          }
        }
      );
    },
    handleSizeChange (val) {
      this.queryParam.pageSize = val;
      this.queryList();
    },
    handleCurrentChange (val) {
      this.queryParam.itemPage = val;
      this.queryList();
    },
    queryList () {
      let param = JSON.parse(JSON.stringify(this.queryParam));
      this.loading = true;
      ApiMethods.UseEnterpriseController.findByPagedEnterpriseList(param)
        .then(result => {
          if (result.success) {
            this.tableList = result.data;
            this.queryParam.pageSize = result.pageSize;
            this.queryParam.itemPage = result.pageNum;
            this.queryParam.total = result.total;
          } else {
            if (this.$store.getters.authUser.identityAuth > -1) {
              this.$message.error(result.description || this.$tip);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /** 重置 */
    rest () {
      this.queryParam = {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        name: null,
        idNo: null,
        accountNo: null,
        mQuery: null
      },
        this.queryList()
    },
    handleSelectionChange: function (val) {
      this.checkedList = val;
    },

    editSignerSubmit () {
      var _this = this;
      _this.$refs.editSignerFrm.validate(valid => {
        if (valid) {
          ApiMethods.UseEnterpriseController.saveEnterpriseList(
            _this.editSignerFrm
          ).then(result => {
            if (result.success) {
              _this.$message.success(result.description || '操作成功')
              this.showEditSignerDialog = false;
              this.queryList();
            } else {
              _this.$message.error(result.description || this.$tip);
            }
          });
        }
      });
    }
  },
  name: "signers"
};
</script>

<style lang="less" scoped>
.nosign-url {
  font-size: 12px;
  color: #666666;
  margin-bottom: 20px;
}

/deep/ .el-button {
  color: rgba(41, 2, 2, 0.45);

  &:hover {
    color: #ffffff;
  }
}

.main-container {
  max-width: 1200px;
  margin: 0 auto;

  .signerHeader {
    width: 100%;
    height: 55px;
    font-size: 16px;
    background: #fff;
    font-weight: 600;
    border-bottom: solid 1px #e5e5e5;
    padding-top: 13px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .leftHeader {
      display: flex;
      align-items: center;
      div {
        width: 5px;
        height: 15px;
        background: #290202;
        margin-right: 10px;
      }
    }
  }
}

.pageation {
  padding: 30px 10px 20px 10px;
  border-top: 0;
}

.dialog-footer {
  padding-bottom: 20px;
  .btn {
    width: 30%;
  }
}

nav.nav-bar {
  width: 100%;
  margin-top: 20px;
  border: 1px dashed #d7d7d7;
  overflow: hidden;
  li.nav-item {
    margin-right: 14px;
    padding: 10px 15px;
    color: #666;
    border: none;
    background: #fff;
    cursor: pointer;
  }
  .nav-item.active {
    color: #ec1c1c;
  }
  ul.nav {
    width: 100%;
  }
}
.color-success {
  color: #290202;
  font-weight: bold;
}
.color-success:hover {
  color: #ec1c1c;
}
</style>



// WEBPACK FOOTER //
// pages/signSettings/signers.vue